export const getProductIdentifier = (
    platform,
    options
) => {
  const defaultKeyByPlatform = platform === "facebook" ? "sku" : "id";
  const { default: defaultKey = defaultKeyByPlatform } = options;
  const gaProductIdentifierKey = process.env.NUXT_PUBLIC_GA_PRODUCT_IDENTIFIER_KEY;
  const fbProductIdentifierKey = process.env.NUXT_PUBLIC_FB_PRODUCT_IDENTIFIER_KEY;

  if (platform === "google" && gaProductIdentifierKey) {
    return options[gaProductIdentifierKey];
  }

  if (platform === "facebook" && fbProductIdentifierKey) {
    return options[fbProductIdentifierKey];
  }

  return options[defaultKey];
};
